module.exports = __webpack_public_path__ + "img/Franziska Heintel.867b2c91.jpg";